<template>
  <side-bar :background-color="sidebarBackground" short-title="Menu" title="Menu">
    <hr />
    <b-button v-if="$route.name == 'dashboard' || $route.name == 'class-list'" variant="primary" size="sm" @click="openJoinClassModal" class="logo-header"><i class="fa fa-user" aria-hidden="true"></i> Gabung Kelas</b-button>
    <template slot="links">
      <sidebar-item
        :link="{
          name: 'Dashboard',
          icon: 'fa fa-home text-custom-primary',
          routeName: 'dashboard',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'murid' && user.isGraduation == '1'"
        :link="{
          name: 'Kelulusan',
          icon: 'fa fa-graduation-cap text-custom-primary',
          routeName: 'graduation',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Setting Background',
          icon: 'fa fa-images text-custom-primary',
          routeName: 'background-setting-list',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Setting Tahun Ajaran',
          icon: 'fa fa-calendar text-custom-primary',
          routeName: 'tahun-ajaran-list',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Upload Kelulusan',
          icon: 'fa fa-graduation-cap text-custom-primary',
          routeName: 'admin-graduation',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Monitoring User Modul',
          icon: 'fa fa-users text-custom-primary',
          routeName: 'user-modul-activity-list',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Users',
          icon: 'fa fa-users text-custom-primary',
          routeName: 'user-setting-list',
          param: null,
        }"
      />
      <sidebar-item
        v-if="($route.name == 'user-activity' || $route.name == 'user-setting-list' || $route.name == 'user-absence') && user.type == 'admin'"
        :link="{
          name: 'Aktivitas User',
          icon: 'fa fa-user-md text-custom-primary',
          routeName: 'user-activity',
          param: { subjectId: currentSubjectId },
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Absensi Siswa',
          icon: 'fa fa-book text-custom-primary',
          routeName: 'user-absence',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Kunci Semester',
          icon: 'fa fa-lock text-custom-primary',
          routeName: 'lock-semester',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Hak Akses Rapor',
          icon: 'fa fa-user-secret text-custom-primary',
          routeName: 'permission-rapor',
          param: null,
        }"
      />
      <sidebar-item
        v-if="user.type == 'admin'"
        :link="{
          name: 'Formulir Pendaftaran',
          icon: 'fa fa-file text-custom-primary',
          routeName: 'formulir-pendaftaran',
          param: null,
        }"
      />
      <sidebar-item
        v-if="($route.name == 'class-detail' || $route.name == 'download-nilai') && user.type == 'admin'"
        :link="{
          name: 'Download Nilai',
          icon: 'fa fa-user-md text-custom-primary',
          routeName: 'download-nilai',
          param: null,
        }"
      />
      <sidebar-item
        v-if="$route.name == 'subject-detail' || $route.name == 'study-instructions' || $route.name == 'student-progress'"
        :link="{
          name: 'Petunjuk Belajar',
          icon: 'fa fa-graduation-cap text-custom-primary',
          routeName: 'study-instructions',
          param: { subjectId: currentSubjectId },
        }"
      />
      <sidebar-item
        v-if="$route.name == 'subject-detail' || $route.name == 'study-instructions' || $route.name == 'student-progress'"
        :link="{
          name: 'Pelajaran',
          icon: 'fa fa-book text-custom-primary',
          routeName: 'subject-detail',
          param: { subjectId: currentSubjectId },
        }"
      />
      <!-- <sidebar-item
          v-if="$route.name == 'subject-detail' || $route.name == 'study-instructions' || $route.name == 'student-progress'"
          :link="{
            name: 'Perkembangan',
            icon: 'fa fa-industry text-custom-primary',
            routeName: 'student-progress',
            param: null
          }"
        /> -->
      <sidebar-item
        v-if="
          $route.name == 'modul-detail' ||
          $route.name == 'modul-discuss' ||
          $route.name == 'task-list' ||
          $route.name == 'modul-appraisal' ||
          $route.name == 'modul-appraisal-question' ||
          $route.name == 'student-task-list' ||
          $route.name == 'appraisal-list' ||
          $route.name == 'student-appraisal-list'
        "
        :link="{
          name: 'Materi',
          icon: 'fa fa-book text-custom-primary',
          routeName: 'modul-detail',
          param: { modulId: currentModulId },
        }"
      />
      <sidebar-item
        v-if="
          $route.name == 'modul-detail' ||
          $route.name == 'modul-discuss' ||
          $route.name == 'task-list' ||
          $route.name == 'modul-appraisal' ||
          $route.name == 'modul-appraisal-question' ||
          $route.name == 'student-task-list' ||
          $route.name == 'appraisal-list' ||
          $route.name == 'student-appraisal-list'
        "
        :link="{
          name: 'Penugasan',
          icon: 'fa fa-file text-custom-primary',
          routeName: 'modul-task',
          param: { modulId: currentModulId },
        }"
      />
      <sidebar-item
        v-if="
          $route.name == 'modul-detail' ||
          $route.name == 'modul-discuss' ||
          $route.name == 'task-list' ||
          $route.name == 'modul-appraisal' ||
          $route.name == 'modul-appraisal-question' ||
          $route.name == 'student-task-list' ||
          $route.name == 'appraisal-list' ||
          $route.name == 'student-appraisal-list'
        "
        :link="{
          name: 'Penilaian',
          icon: 'fa fa-suitcase text-custom-primary',
          routeName: 'modul-appraisal',
          param: { modulId: currentModulId },
        }"
      />
      <sidebar-item
        v-if="
          $route.name == 'modul-detail' ||
          $route.name == 'modul-discuss' ||
          $route.name == 'task-list' ||
          $route.name == 'modul-appraisal' ||
          $route.name == 'modul-appraisal-question' ||
          $route.name == 'student-task-list' ||
          $route.name == 'appraisal-list' ||
          $route.name == 'student-appraisal-list'
        "
        :link="{
          name: 'Diskusi',
          icon: 'fa fa-comments text-custom-primary',
          routeName: 'modul-discuss',
          param: { modulId: currentModulId },
        }"
      />
      <div v-if="user.type == 'admin' || (user.type == 'tutor' && user.raporPermission === '1')" style="margin-top: 10px">
        <a :href="baseRaporUrl + '/main-sign-in?ctkn=' + encodeURIComponent(token2)" class="icon-clicked external-link" target="_blank"
          ><i class="fa fa-book-open color-icon" aria-hidden="true"></i><span style="margin-left: 20px">Rapor</span></a
        >
      </div>
    </template>
  </side-bar>
</template>
<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/eventBus.js";
import Cookies from "js-cookie";
import axios from "../../axiosHelper";

export default {
  components: {},
  data() {
    return {
      sidebarBackground: "red", //vue|blue|orange|green|red|primary
      token2: "",
      baseRaporUrl: axios.defaults.raporUrl,
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      currentSubjectId: "getCurrentSubjectId",
      currentModulId: "getCurrentModulId",
    }),
  },
  methods: {
    openJoinClassModal() {
      EventBus.$emit("showJoinClassModal", true);
    },
  },
  created() {
    this.token2 = Cookies.get("token2"); // Mengambil nilai token dari cookie
  },
};
</script>
<style lang="css" scoped>
.btn-primary {
  color: #fff;
  background-color: #ca062a;
  border-color: #ca062a;
}
.btn-primary:hover,
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:focus {
  color: #fff;
  background-color: #ca062a;
  border-color: #ca062a;
  -webkit-box-shadow: unset;
  box-shadow: unset;
}
</style>
